import React, { useEffect, useState } from 'react';

import { WysiwygField } from '../../../components';

const MarketoForm = ({ entity }) => {
  const marketoId = entity.getIn(['field_marketo_id', 0, 'value']);
  const formId = marketoId.split('/')[1];
  const munchkinId = marketoId.split('/')[0];
  const title = entity.getIn(['field_title', 0, 'value']);
  const text = entity.getIn(['field_text', 0, 'processed']);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const removeInlineMarketoStyling = (form) => {
    const formEl = form.getFormElem()[0];

    // remove element styles from root and children (may want to disable this while debugging)
    for (
      let elsWithStyles = document.querySelectorAll(
          `#${formEl.id}, #${formEl.id} [style]`,
        ),
        i = 0,
        imax = elsWithStyles.length;
      i < imax;
      i++
    ) {
      elsWithStyles[i].removeAttribute('style');
    }
  };

  const alterMarketoFormDom = (removeStyleSheets) => {
    if (removeStyleSheets) {
      // Remove all Markteto stylesheets
      document.getElementById('mktoForms2BaseStyle').remove();
      document.getElementById('mktoForms2ThemeStyle').remove();
      document.querySelector('.mktoForm style').remove();
    }

    // Add wrapping class .form-item for each input section
    document.getElementsByClassName('mktoFieldDescriptor').forEach((item) => item.classList.add('form-item'));
    document.getElementsByClassName('mktoButtonRow').forEach((item) => item.classList.add('form-item', 'form-item--double-spacing'));

    // Make a distiction between radio inputs and field inputs
    document.querySelectorAll('.mktoField:not([type="radio"]):not([type="checkbox"]):not([type="hidden"])').forEach((item) => {
      item.parentNode.parentNode.classList.add('input-field');
    });

    // For each field input move the label and add class .input-container to the input wrapper
    document.querySelectorAll('.input-field').forEach((item) => {
      const label = item.getElementsByTagName('label')[0];
      item.getElementsByClassName('mktoFieldWrap')[0].classList.add('input-container', 'no-csv');
      if (label) item.prepend(label);
    });

    document.querySelectorAll('.mktoField').forEach((item) => {
      item.addEventListener('change', (e) => {
        const valid = item.classList.contains('mktoValid');
        const invalid = item.classList.contains('mktoInvalid');
        const inputContainer = item.parentNode;

        if (valid) {
          inputContainer.classList.add('valid');
          inputContainer.classList.remove('error');
        } else if (invalid) {
          inputContainer.classList.add('error');
          inputContainer.classList.remove('valid');
        }
      });
    });

    document.querySelector('.mktoForm').addEventListener('submit', (e) => {
      const form = document.querySelector('.mktoForm');

      setTimeout(() => {
        form.querySelectorAll('.mktoField').forEach((item) => {
          const valid = item.classList.contains('mktoValid');
          const invalid = item.classList.contains('mktoInvalid');
          const inputContainer = item.parentNode;

          if (inputContainer.classList.contains('input-container')) {
            if (valid) {
              inputContainer.classList.add('valid');
              inputContainer.classList.remove('error');
            } else if (invalid) {
              inputContainer.classList.add('error');
              inputContainer.classList.remove('valid');
            }
          }
        });
      }, 0);
    });

    // Hide * for required fields
    document.getElementsByClassName('mktoAsterix').forEach((item) => item.style.display = 'none');

    // Wrap each radio/checkbox + label in its own div
    document.querySelectorAll('.mktoField[type="radio"], .mktoField[type="checkbox"]').forEach(
      (item) => {
        const wrapper = document.createElement('div');
        const label = item.nextElementSibling;
        wrapper.classList.add(`form-type-${item.getAttribute('type')}`);
        item.parentNode.insertBefore(wrapper, item);
        wrapper.appendChild(item);
        wrapper.appendChild(label);
      },
    );

    // For a single checkbox
    document.querySelectorAll('.mktoCheckboxList')
      .forEach((item) => {
        const totalCheckboxes = document.querySelectorAll('.mktoCheckboxList > div').length;

        if (totalCheckboxes === 1) {
          const label = item.parentNode.getElementsByTagName('label')[0];
          const labelValue = label.innerText;
          item.getElementsByTagName('label')[0].textContent = labelValue;
          label.remove();
        }
      });

    // Add classes to style the submit button
    document.querySelectorAll('.mktoButtonWrap > button').forEach((item) => item.classList.add('button', 'button--primary', 'button--center'));
  };

  useEffect(() => {
    const scriptId = 'mktoScript';
    const existing = document.querySelector(`#${scriptId}`);

    if (existing) {
      setIsScriptLoaded(true);

      return;
    }

    const scriptTag = document.createElement('script');
    scriptTag.id = scriptId;
    scriptTag.src = '//connect.hvcgroep.nl/js/forms2/js/forms2.min.js';

    scriptTag.addEventListener('load', () => {
      setIsScriptLoaded(true);
    });

    document.body.appendChild(scriptTag);
  }, [setIsScriptLoaded]);

  useEffect(() => {
    if (!loaded && isScriptLoaded) {
      window.MktoForms2.loadForm(
        '//connect.hvcgroep.nl',
        munchkinId,
        formId,
      );
      window.MktoForms2.whenReady((form) => {
        removeInlineMarketoStyling(form);
        alterMarketoFormDom(!!document.getElementById('mktoForms2ThemeStyle'));
      });
      setLoaded(true);
    }
  }, [munchkinId, formId, loaded, isScriptLoaded]);

  return (
    <div className="MarketoForm">
      <h2>{title}</h2>
      <WysiwygField
        property="schema:text"
        html={text}
      />
      <form id={`mktoForm_${formId}`} />
    </div>
  );
};

export default MarketoForm;
